import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { DateRange } from "@angular/material/datepicker";
import moment from "moment";

export const DateRangeValidatorCustom = (maxMonths: number = 3): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateRange = control.value as DateRange<Date | null>;

    if (!dateRange?.start || !dateRange?.end) {
      return null;
    }

    const timeDiff = moment(dateRange.end).diff(moment(dateRange.start), 'months', true);

    if (Math.round(Math.abs(timeDiff)) > maxMonths) {
      return {
        rangeGreatherThanThreeMonths: true,
        maxMonths: maxMonths,
        actualMonths: Math.round(Math.abs(timeDiff))
      };
    }

    return null;
  };
};
